import { secureKey } from './format.js';

/**
 * One idempotency key per checkout attempt (pre-launch audit, 25 Oct 2026). An order paid with credit, or free, is placed the
 * moment the server gets it; if the answer is lost, the next tap of Pay must send the same key so the server hands back that
 * order instead of placing a second one and taking the credit twice. The key changes only when what is being bought changes
 * (`identity`: the way of paying, the code, the note, the time, a guest's details), after the order is placed, or on reset.
 */
export class CheckoutKey {
  private cur: { key: string; identity: string } | null = null;
  constructor(private readonly make: () => string = secureKey) {}
  get(identity: string): string {
    if (!this.cur || this.cur.identity !== identity) this.cur = { key: this.make(), identity };
    return this.cur.key;
  }
  reset(): void {
    this.cur = null;
  }
}
